export const UPDATE = "rooms/UPDATE";
export const APPEND = "rooms/APPEND";
export const UPDATE_ONE = "rooms/UPDATE_ONE";
export const DESTROY = "rooms/DESTROY";
export const LOADING = "rooms/LOADING";
